import React, { FC } from "react";
import { useTranslation } from "core/hooks/use-translation.hook";

export const PageNotFound: FC = () => {
    const { t } = useTranslation();

    return <div>404 - {t("page-not-found")}</div>;
};
